module.exports = __webpack_public_path__ + "resources/img/img-glassdome-omnibus-jp.166784aad36ddc4a6ee7dd4a13eb5bd7.png";